import React from 'react';
import {analyticsText} from '../../analyticsText';
import './styles.css';

interface Props {
  hideNotStarted?: boolean;
}

const TableLegend = ({hideNotStarted}: Props) => {
  return (
    <div className="TableLegend">
      <div className="TableLegendItem">
        <div className="Completed" />
        <span>{analyticsText.completed}</span>
      </div>
      <div className="TableLegendItem">
        <div className="Failed" />
        <span>{analyticsText.failed}</span>
      </div>
      <div className="TableLegendItem">
        <div className="Progress" />
        <span>{analyticsText.inProgress}</span>
      </div>
      {!hideNotStarted && (
        <div className="TableLegendItem">
          <div className="NotStarted" />
          <span>{analyticsText.notStarted}</span>
        </div>
      )}

      <div className="TableLegendItem">
        <div className="Unassigned">
          <div className="UnassignedDash" />
        </div>
        <span>
          {hideNotStarted ? analyticsText.notStarted : analyticsText.unassigned}
        </span>
      </div>
    </div>
  );
};

export default TableLegend;
